import * as React from "react";
import type { SVGProps } from "react";
const ForwardPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M4.5 6.227v11.546c0 .863 1.02 1.32 1.664.747l5.336-4.742v3.995c0 .863 1.02 1.32 1.664.747l6.495-5.773a1 1 0 0 0 0-1.494l-6.495-5.774c-.644-.573-1.664-.115-1.664.748v3.995L6.164 5.48C5.52 4.906 4.5 5.364 4.5 6.227" clipRule="evenodd" /></svg>;
export default ForwardPanelIcon;